<template>
  <b-card
    class="back-overflow border-primary"
    no-body
  >
    <div class="bg-light-primary rounded-top text-center">
      <b-img
        v-if="apartment_info.image"
        :src="apartment_info.image.url"
        :alt="apartment_info.title"
        height="170"
      />
      <b-img
        v-else
        :src="require('@/assets/images/pages/login/login_main.svg')"
        :alt="apartment_info.title"
        height="170"
        style="object-fit: cover; width: 100%; opacity: 0.4;"
      />
    </div>
    <div
      class="back-size-pos"
      :class="{'bg-light-info': !apartment_info.image}"
    >

      <div class="mx-auto mb-1">
        <h4 class="mx-auto m-1 text-center">
          {{ apartment_info.name }}
        </h4>
        <h3 class="text-center">
          {{ apartment_info.title }}
        </h3>
        <hr class="mb-2">
        <div class="d-flex justify-content-center text-center align-items-center">
          <div class="mr-4">
            <h6 class="text-muted font-weight-bolder">
              {{ $t('objects.residential') }}
            </h6>
            <h5 class="mb-0 align-content-center">
              {{ apartment_info.flat_count.living }}
            </h5>
          </div>
          <div class="ml-4 align-items-center">
            <h6 class="text-muted font-weight-bolder">
              {{ $t('objects.not_residential') }}
            </h6>
            <h5 class="mb-0">
              {{ apartment_info.flat_count.non_living }}
            </h5>
          </div>
        </div>
      </div>
    </div>

    <b-row class="text-center bg-primary mx-0">
      <b-col
        :cols="GET_USER_PERMISSIONS.includes('content_management') || GET_USER_PERMISSIONS.includes('manager') ? 6 : 12"
        class="border-top border-right d-flex align-items-between flex-column py-1"
      >
        <b-card-text class=" mb-0">
          <b-link
            class="text-white"
            :to="{name: 'apartment-view', params: { id: apartment_info.id }}"
          >
            {{ GET_USER_PERMISSIONS.includes('content_management') ? $t('generals.edit') : $t('generals.show') }}
          </b-link>
        </b-card-text>
      </b-col>
      <b-col
        v-if="GET_USER_PERMISSIONS.includes('content_management') || GET_USER_PERMISSIONS.includes('manager') "
        cols="6"
        class="border-top d-flex align-items-between flex-column py-1"
      >
        <b-card-text class="text-muted mb-0">
          <b-link
            class="text-white"
            @click="deactivateApartment"
          >
            {{ $t('generals.delete') }}
          </b-link>
        </b-card-text>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BCardText,
  BLink,
} from 'bootstrap-vue'
import {
  mapActions,
  mapGetters,
} from 'vuex'

export default {
  name: 'ObjectCard',
  components: {
    BCard,
    BRow,
    BImg,
    BCol,
    BCardText,
    BLink,
  },
  props: {
    apartment_info: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
  },
  methods: {
    ...mapActions('apartments', ['EDIT_APARTMENT']),
    buttonClick() {
      this.$emit('click')
    },
    deactivateApartment() {
      this.$_showAreYouSureModal().then(value => {
        if (value) {
          this.EDIT_APARTMENT({
            id: this.apartment_info.id,
            is_active: false,
          }).then(() => {
            this.$emit('deactivated')
            this.$_successToast(this.$t('generals.deleted'))
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
  },
}
</script>

<style scoped>
  .back-size-pos {
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }

  .back-overflow {
    overflow: hidden;
  }
</style>
